import { FrontEndMapService } from './api/FrontEndMapService'
import { MapModelData } from './models/MapModel'

const MapModule = {
  namespaced: true,
  state: MapModelData(),
  getters: {
    fetchMapAbbrivationResult: state => state.mapAbbrivationResult,
    fetchMetaData: state => state.metaDataObject
  },
  mutations: {
    setMapAbbrivationResult (state, data) {
      state.mapAbbrivationResult = data.list
    },
    setMetaData (state, data) {
      state.metaDataObject.timeStamp = data.timeStamp
      state.metaDataObject.entitySeal = data.entitySeal
      state.metaDataObject.entityName = data.entityName
      state.metaDataObject.entityAbbreviation = data.entityAbbreviation
      state.metaDataObject.jurisdictionUrl = data.jurisdictionUrl
      state.metaDataObject.amendmentUrl = data.amendmentUrl
      state.metaDataObject.jurisdictionProfile = data.jurisdictionProfile
      state.metaDataObject.adoptionLevel = data.adoptionLevel
      state.metaDataObject.stateName = data.stateName
      state.metaDataObject.countyName = data.countyName
      state.metaDataObject.countryAbbr = data.countryAbbr
      state.metaDataObject.stateAbbr = data.stateAbbr
      state.metaDataObject.metaCountyList = data.metaCountyList
      state.metaDataObject.metaPostalList = data.metaPostalList
      state.metaDataObject.adoptionDescription = data.adoptionDescription
      state.metaDataObject.usefulLinks = data.usefulLinks
    }
  },
  actions: {
    /**
     * Get state list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getNameFromAbbreviationList ({ commit }, { resolve, reject, formData }) {
      try {
        const response = await FrontEndMapService.fetchNameFromAbbreviationList(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('setMapAbbrivationResult', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setMapAbbrivationResult', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default MapModule
